import Intercom, {
  trackEvent as trackEvenSdk,
  update
} from '@intercom/messenger-js-sdk'

// PLA-1263: the Messenger is authenticated with the JWT minted by the CM API
// `/init` response. The user's current home travels inside that JWT as the
// `company` claim, which is the only place Intercom reads company data from
// once a JWT is present. A boot must not carry `user_hash` alongside the JWT,
// and a boot-level `company` object would be ignored, so neither is sent.
export const initialiseIntercom = ({
  INTERCOM_APP_ID,
  INTERCOM_USER_JWT,
  user
}: {
  INTERCOM_APP_ID: string
  INTERCOM_USER_JWT: string
  user: {
    id: string
    name: {
      first?: string
      last?: string
    }
  }
}) => {
  Intercom({
    app_id: INTERCOM_APP_ID,
    user_id: user.id,
    intercom_user_jwt: INTERCOM_USER_JWT,
    name: `${user.name.first || ''} ${user.name.last || ''}`
  })
}

// export const isIntercomInitialised = () => {
// 	Intercom.boot
// }

export const showIntercom = () => update({ hide_default_launcher: false })
export const hideIntercom = () => update({ hide_default_launcher: true })
export const trackEvent = (eventName: string) => trackEvenSdk(eventName)
export const checkReady = () => {
  try {
    if (typeof Intercom === 'function') {
      return true
    }
  } catch {
    return false
  }
  return false
}

export default initialiseIntercom
